import React from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import moment from 'moment'
import {
  DcBreadcrumbs,
  DcDateRangePicker,
  DcFlexBox,
  PixelDiv,
  PixelPageContainer,
  PixelSpinner,
  Section,
  SectionActions,
  SectionContent,
  SectionTitle,
  // PixelFactoryContext,
  colors,
} from 'pixel-base'

import HeatingHours from './components/HeatingHours'

const breadcrumbs = [
  {
    name: 'Analytics',
    active: false,
  },
  {
    name: 'Order Process Funnel',
    active: true,
  },
]

const OrderProcessFunnel = () => {
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)

  const [filters, setFilters] = React.useState({
    start_date: new Date()?.setDate(new Date()?.getDate() - 30),
    end_date: new Date(),
  })
  // const [data, setData] = React.useState([])
  // const getOrderProcessFunnel = (filters) => {
  //   showLoader(OrderProcessFunnelRef)
  //   get('/orders-process-funnel/all', filters).subscribe((res) => {
  //     const responseData = res.response
  //     if (responseData) {
  //       hideLoader(OrderProcessFunnelRef)
  //       setData(responseData?.data)
  //     }
  //   })
  // }

  // React.useEffect(() => {
  //   getOrderProcessFunnel(formateDate(filters))
  // }, [])
  const formateDate = (filters) => {
    return {
      start_date: moment(filters.start_date).format('YYYY-MM-DD'),
      end_date: moment(filters.end_date).format('YYYY-MM-DD'),
    }
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: `1px solid ${colors.grayBorderLight}`,
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <PixelPageContainer
        style={{ padding: '0px', height: 'calc(100vh - 60px)' }}
      >
        <PixelSpinner isShow={isShowSpinner} />
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <SectionActions
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                height: '40px',
                padding: '5px 20px',
              }}
            >
              <DcDateRangePicker
                size="sm"
                month={2}
                ranges={filters}
                onApply={() => {
                  getOrderProcessFunnel(formateDate(filters))
                }}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    start_date: new Date(e.range1.startDate),
                    end_date: new Date(e.range1.endDate),
                  })
                }}
              />
            </SectionActions>
          </SectionContent>
        </Section>
        <Section
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            padding: '20px',
            height: 'calc(100vh - 101px)',
            overflow: 'auto',
          }}
        >
          <SectionContent style={{ minHeight: '700px', width: '100%' }}>
            <DcFlexBox height="auto" flexDirection="column">
              <SectionTitle>
                <PixelDiv style={{ width: '50%' }}>Heat Map</PixelDiv>
              </SectionTitle>
              <HeatingHours setIsShowSpinner={setIsShowSpinner} />
            </DcFlexBox>
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default OrderProcessFunnel
